/**
 * Defines an {@link HTMLScriptElement} whose source is in
 * classic JavaScript.
 */
export interface ClassicSource {
  classic: string;
}

/**
 * A type guard for testing that an object is assignable to the {@link ClassicSource}
 * type.
 *
 * @param argument
 */
export const isClassicSource = (argument: any): argument is ClassicSource => {
  // prettier-ignore
  return typeof argument === "object"
      && argument !== null
      && "classic" in argument
      && typeof argument.classic === "string";
};
